<template>
  <div
    id="thirdNav"
    v-show="(this.isFlagSpanSome() && isFlagLiClass === null)"
    :thirdNavigationType="thirdNavigationType"
    :thirdNavigationState="thirdNavigationState"
  >
    <div class="thirdNavDivClass">
      <h1 class="thirdNavH1Class">{{ this.thirdNavigationTitle(isFlagSpanClass) }}</h1>
      <div class="primaryDivClass" :addProjectDomClick="'addProjectDomClick'" v-show="isFlagSpanClass === 'MyProjectsList'">
        <div
          :addProjectDomClick="'addProjectDomClick'"
          @click="primaryBtnFlag(isPrimaryFlag)"
          style="position: relative; background-color: rgba(255, 255, 255, 0.2);"
        >
          <button :addProjectDomClick="'addProjectDomClick'" class="primaryBtnClass">
            <span :addProjectDomClick="'addProjectDomClick'" class="primarySpanText">{{ $t('userRoles.button.new') }}</span>
          </button>
          <span class="primarySpanLine"></span>
          <el-collapse-transition>
          <div class="newProjectDiv" v-show="$store.state.globalSelectControlState === 'addProjectDomClick' && false">
            <ul class="newProjectUl">
              <li
                v-for="(o, i) in contentTypes"
                :key="i"
                @click="handleProjectState(o.code)"
                :class="{ stateTypeClass:primaryClassState === o.code }"
              ><span :atr="o.name">{{ o.name }}</span></li>
            </ul>
          </div>
          </el-collapse-transition>
        </div>
      </div>

      <div style="width:896px;margin:auto;text-align: right;"></div>
      <div style="width:896px;margin:auto;display:flex;line-height:27px;">
        <div class="_div">
          <el-input v-model="search" size="mini" class="_input" :placeholder="$t('table.common.search.placeholder')"/>
          <i class="_sprite_class" @click="searchFunc"></i>
        </div>
        <div
          style="display:inline-block;margin-left:28px;cursor:pointer;line-height: 30px;"
          @click="triggerFunc"
        >
          <i class="filterShowClass" style="margin-right:5px;"></i>
          <span>{{ $t('userRoles.header.show.filter') }}</span>
        </div>

        <div>
          <div
            class="allTypeDiv"
            :style="isFlagSpanClass === 'MyProjectsList' ? 'width: 138px;' : 'width: 94px;'"
          >
            <div
              class="allTypeChildDiv"
              :typeDomClick="'typeDomClick'"
              @click="typeStateFunc(true)"
              :class="{ typeBack: $store.state.globalSelectControlState === 'typeDomClick' }"
            >
              <span :typeDomClick="'typeDomClick'" style="display:flex;flex-grow:1;">{{ $t('common.ThirdNavigation.select.type.all') }}</span>
              <i :typeDomClick="'typeDomClick'" class="allTypeFilter"></i>
            </div>
            <el-collapse-transition>
            <div class="rightBoxA" v-show="allType && isFlagSpanClass !== 'MyProjectsList'"></div>
            </el-collapse-transition>
            <el-collapse-transition>
            <div class="rightBox" v-show="allType && isFlagSpanClass !== 'MyProjectsList'"></div>
            </el-collapse-transition>
            <el-collapse-transition>
            <ul
              :typeDomClick="'type'"
              class="allTypeUl"
              v-show="$store.state.globalSelectControlState === 'typeDomClick'"
              :style="isFlagSpanClass === 'MyProjectsList' ? 'top: 26px;' : 'top: 39px;'"
            >
              <li
                :typeDomClick="'type'"
                v-for="(o, i) in contentTypeItems"
                :key="i"
                :class="{ stateTypeClass: typeFlag === o.code }"
                :style="isFlagSpanClass === 'MyProjectsList' ? 'width: 136px;' : 'width: 94px;'"
                @click="handleTypeState('0', o.code)"
              >
                <span :typeDomClick="'type'" class="myProjectsStateType">{{ $t(o.name) }}</span>
              </li>
            </ul>
            </el-collapse-transition>
          </div>
        </div>
        <div>
          <div
            class="allTypeDiv"
            v-show="isFlagSpanClass === 'orderManagment' || isFlagSpanClass === 'MyProjectsList'"
            :style="isFlagSpanClass === 'MyProjectsList' ? 'width: 138px;' : 'width: 94px;' "
          >
            <div
              :stateDomClick="'stateDomClick'"
              class="allTypeChildDiv allStateChildDiv"
              :class="{ stateBack: $store.state.globalSelectControlState === 'stateDomClick' }"
              @click="typeStateFunc(false) "
            >
              <span  :stateDomClick="'stateDomClick'" style="display:flex;flex-grow:1;">{{ $t('common.ThirdNavigation.select.state.all') }}</span>
              <i :stateDomClick="'stateDomClick'" class="allTypeFilter"></i>
            </div>
            <el-collapse-transition>
            <div class="rightBoxA" v-show="allState && isFlagSpanClass !== 'MyProjectsList'"></div>
            </el-collapse-transition>
            <el-collapse-transition>
            <div class="rightBox" v-show="allState && isFlagSpanClass !== 'MyProjectsList'"></div>
            </el-collapse-transition>
            <el-collapse-transition>
            <ul
             :stateDomClick="'sate'"
              class="allTypeUl"
              v-show="$store.state.globalSelectControlState === 'stateDomClick'"
              :style="isFlagSpanClass === 'MyProjectsList' ? 'top: 26px;' : 'top: 39px;'"
            >
              <li
               :stateDomClick="'sate'"
                v-for="(o, i) in contentstateItems"
                :key="i"
                :class="{ stateTypeClass: stateFlag === o.code }"
                :style="isFlagSpanClass === 'MyProjectsList' ? 'width: 136px;' : 'width: 94px;'"
                @click="handleTypeState('1', o.code)"
              >
                <span :stateDomClick="'sate'" :atr="o.name" class="myProjectsStateType">{{ $t(o.name) }}</span>
              </li>
            </ul>
            </el-collapse-transition>
          </div>
        </div>
        <span style="display:flex;flex-grow:1;"></span>
        <div
          style="cursor:pointer;color:#333333;display:inline-block;"
          v-show="isFlagSpanClass === 'appAnalysis'"
        >
          <span style="margin-right:3px;font-size: 14px;vertical-align: middle;">{{ $t('table.common.thirdNav.about') }}</span>
            <el-tooltip transition="el-fade-in" popper-class="appAnalysisTooltipItem" effect="light" placement="bottom">
                <div slot="content">
                    <p>
                        <span style="margin-bottom:4px;display: inline-block;">{{ $t('table.common.thirdNav.appAnalysis.about.toolTop') }}</span>
                        <span>{{ $t('table.common.thirdNav.appAnalysis.about.toolBot') }}</span>
                    </p>
                </div>
            <i class="aboutNews"></i>
        </el-tooltip>
        </div>
        <div
          style="color:#333333;display:inline-block;"
          v-show="isFlagSpanClass === 'orderManagment'"
        >
          <span style="margin-right:10px;font-size: 14px;">{{ orderSumAll }} {{ $t('financialStatistics.table.total') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data () {
        return {
            search: '',
            allType: false,
            allState: false,
            stateFlag: null,
            typeFlag: null,
            contentTypeItems: [],
            contentstateItems: [],
            // 我的专案
            contentTypes: [],
            isPrimaryFlag: false,
            primaryClassState: ''
        }
    },
    mounted () {
        this.pubContentTypes()
        // type
        this.typeItemFunc()
        // state
        this.stateItemFunc()
    },
    methods: {
        primaryBtnFlag (flag) {
            // console.log(flag, 'primaryBtnFlag')
            // !flag && (this.isPrimaryFlag = !this.isPrimaryFlag)
            // flag && (this.isPrimaryFlag = false)
            // if (!this.isPrimaryFlag) {
            //     this.primaryClassState = null
            // }
        },
        pubContentTypes () {
            this.contentTypes = [
                {
                    code: 'application',
                    name: this.$t('common.ThirdNavigation.select.type.application')
                },
                {
                    code: 'content',
                    name: this.$t('common.ThirdNavigation.select.type.storyDance')
                },
                {
                    code: 'd',
                    name: this.$t('common.ThirdNavigation.select.type.stories')
                },
                {
                    code: 'e',
                    name: this.$t('common.ThirdNavigation.select.type.integratedPackage')
                }
            ]
        },
        handleProjectState (type) {
            // this.isPrimaryFlag = false
            // this.$store.state.MyProjectsAddState = type
            // this.primaryClassState = type
        },
        typeItemFunc () {
            this.contentTypeItems = [
                {
                    code: null,
                    name: 'common.ThirdNavigation.select.type.all'
                },
                {
                    code: 'application',
                    name: 'common.ThirdNavigation.select.type.application'
                },
                {
                    code: 'content',
                    name: 'common.ThirdNavigation.select.type.storyDance'
                },
                {
                    code: 'd',
                    name: 'common.ThirdNavigation.select.type.stories'
                },
                {
                    code: 'e',
                    name: 'common.ThirdNavigation.select.type.integratedPackage'
                }
            ]
        },
        stateItemFunc () {
            let stateData = []
            if (this.isFlagSpanClass === 'MyProjectsList') {
                stateData = [
                    {
                        code: null,
                        name: 'common.ThirdNavigation.select.state.all'
                    },
                    {
                        code: 'Draft',
                        name: 'common.ThirdNavigation.select.state.draft'
                    },
                    {
                        code: 'Ready for Sale',
                        name: 'common.ThirdNavigation.select.state.readySell'
                    },
                    {
                        code: 'unpaid',
                        name: 'common.ThirdNavigation.select.state.refused'
                    },
                    {
                        code: 'e',
                        name: 'common.ThirdNavigation.select.state.waitingReview'
                    }
                ]
            } else {
                this.primaryBtnFlag(true)
                stateData = [
                    {
                        code: null,
                        name: 'common.ThirdNavigation.select.state.all'
                    },
                    {
                        code: 'paid',
                        name: 'common.ThirdNavigation.select.state.payment'
                    },
                    {
                        code: 'b',
                        name: 'common.ThirdNavigation.select.state.waitingPayment'
                    },
                    {
                        code: 'unpaid',
                        name: 'common.ThirdNavigation.select.state.paymentFailure'
                    },
                    {
                        code: 'e',
                        name: 'common.ThirdNavigation.select.state.partRefund'
                    }
                ]
            }
            this.contentstateItems = stateData
        },
        isFlagSpanSome () {
            let arr = ['appAnalysis', 'orderManagment', 'MyProjectsList']
            return arr.some(item => this.isFlagSpanClass === item)
        },
        thirdNavigationTitle (name) {
            let obj = {
                orderManagment: this.$t('table.common.thirdNav.orderManagment.title'),
                MyProjectsList: this.$t('table.common.thirdNav.myprojects.title'),
                appAnalysis: this.$t('table.common.thirdNav.appAnalysis.title')
            }
            return obj[Object.keys(obj).filter(item => item === name)[0]]
        },
        searchFunc () {
            this.$store.state.thirdNavigationIdentify = 'search'
            this.$store.state.thirdNavigationSearch = this.search
        },
        handleTypeState (type, data) {
            if (type === '1') {
                this.$store.state.thirdNavigationState = data
                this.stateFlag = data
            } else {
                this.$store.state.thirdNavigationType = data
                this.typeFlag = data
            }
        },
        triggerFunc () {
            this.$store.state.thirdNavigationIdentify = 'true'
        },
        typeStateFunc (type) {
            if (type) {
                this.allType = !this.allType
                if (!this.allType) {
                    // console.log('allType')
                    // this.$store.commit('globalSelectControlFn', { key: 'globalSelectControlState', status: false })
                }
            } else {
                this.allState = !this.allState
                if (!this.allState) {
                    // console.log('allState')
                    // this.$store.commit('globalSelectControlFn', { key: 'globalSelectControlState', status: false })
                }
            }
        }
    },
    computed: {
        isFlagSpanClass () {
            // 离开页面清空search
            this.search = ''
            return this.$store.state.isFlagSpanClass
        },
        isFlagLiClass () {
            return this.$store.state.isFlagLiClass
        },
        orderSumAll () {
            return this.$store.state.orderSumAll
        },
        thirdNavigationType () {
            return this.$store.state.thirdNavigationType
        },
        thirdNavigationState () {
            return this.$store.state.thirdNavigationState
        }
    },
    watch: {
        search () {
            if (!this.search) {
                this.$store.state.thirdNavigationIdentify = 'search'
                this.$store.state.thirdNavigationSearch = this.search
            }
            // 搜索的同时进行筛选
            this.searchFunc()
            return this.search
        },
        isFlagSpanClass () {
            this.typeFlag = null
            this.stateFlag = null
            this.allType = false
            this.allState = false
            this.stateItemFunc()
            return this.isFlagSpanClass
        },
        thirdNavigationType () {
            this.typeFlag = this.thirdNavigationType
            return this.thirdNavigationType
        },
        thirdNavigationState () {
            this.stateFlag = this.thirdNavigationState
            return this.thirdNavigationState
        }
    }
}
</script>

<style scoped>
ul,
li,p {
    margin: 0px;
    padding: 0px;
    list-style: none;
}
#thirdNav {
    font-family: sans-serif;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
}
.thirdNavH1Class{
    width: 896px;
    font-size: 40px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 2.2px;
    color: #333333;
    margin: 0px auto;
    padding-top: 40px;
    margin-bottom: 25px;
}
.thirdNavDivClass{
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    width:1280px;
    z-index:2;
    position:fixed;
    background: #fff;
    color: #333333;
    padding-bottom:15px;
    box-shadow: 0 2px 5px 0 rgba(51, 51, 51, 0.1);
}
/* 我的专案清单 */
.myProjectsStateType {
    display: inline-block;
    padding: 0px 11px;
    width: 100%;
    margin: 6px 0px;
    box-sizing: border-box;
}
.myProjectsStateType:hover {
    margin-top: 4px;
    margin-bottom: 8px;
    opacity: .5;
}
.primarySpanText {
    display: block;
    width: 100%;
    height: 100%;
    margin-top: 11px;
}
/* .primarySpanText:hover { */
    /* margin-top: 9px; */
    /* cursor: not-allowed; */
/* } */
/* 我的专案 */
.primaryBtnClass {
    width: 165px;
    height: 50px;
    border-radius: 10px;
    background-color: #00b5e2;
    outline: none;
    border: none;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
    /* cursor: pointer; */
    cursor: not-allowed;
}
.primaryDivClass {
    position: absolute;
    top: 42px;
    right: 193px;
}
.primarySpanLine {
    width: 145px;
    height: 2px;
    background: rgba(51, 51, 51, 0.3);
    display: block;
    position: absolute;
    margin-top: -2px;
    left: 11px;
}
.newProjectDiv {
    position: absolute;
    top: 50px;
    right: 0px;
    padding: 7px 0px 5px 0px;
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-radius: 8px;
    box-shadow: 2px 2px 10px 0 rgba(51, 51, 51, 0.3);
    background-color: #ffffff;
}
.newProjectUl li {
    width: 218px;
    height: 50px;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 1px;
    color: #333333;
    line-height: 50px;
    padding-left: 11px;
    box-sizing: border-box;
}
.newProjectUl li:hover {
    background: rgba(0, 224, 218, 0.1);
}
/* 伪元素 */
.newProjectUl li:active > span {
   color: #00b5e2;
   font-weight: 500;
   opacity: 1;
   box-sizing: border-box;
}
.newProjectUl li > span::after{
  display: block;
  content: attr(atr);
  font-weight: 500;
  visibility: hidden;
  height: 1px;
  color: transparent;
  margin-bottom: -1px;
  overflow: hidden;
}
/* 伪元素 */
.typeBack {
    /* background-color: rgba(51, 51, 51, 0.05); */
    border-color: rgba(0, 224, 218, 0.5) !important;
}
.allTypeChildDiv:hover {
    background-color: rgba(51, 51, 51, 0.05);
}
.allTypeChildDiv:active {
    background-color: rgba(0, 224, 218, 0.1);
}
.allStateChildDiv:hover {
   background-color: rgba(51, 51, 51, 0.05);
}
.allStateChildDiv:active {
    background: rgba(0, 224, 218, 0.1);
}
.stateBack {
    border-color: rgba(0, 224, 218, 0.5) !important;
}
.stateTypeClass {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 500 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #00b5e2 !important;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: absolute;
    top: 33px;
    left: 48%;
    transition: .3s;
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: 35px;
    position: absolute;
    left: 47px;
    z-index: 3;
    transition: .3s;
}
.allTypeUl li {
    width: 72px;
    /* height: 18px; */
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #333333;
}

.allTypeUl li:hover {
    background: rgba(0, 224, 218, 0.1);
}
.allTypeUl {
    padding: 6px 0px 6px 0px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border: 1px solid rgba(51, 51, 51, 0.3);
    border-radius: 4px;
    position: absolute;
    top: 39px;
    cursor: default;
}
.allTypeDiv {
    margin-left: 10px;
    position: relative;
    cursor: pointer;
    width: 94px;
}
.allTypeChildDiv {
    padding: 1px 9px;
    border-radius: 4px;
    line-height: 24px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ffffff;
}
/* 伪元素 */
.allTypeUl li:active > span {
   color: #00b5e2;
   font-weight: 500;
   opacity: 1;
   box-sizing: border-box;
}
.allTypeUl li > span::after{
  display: block;
  content: attr(atr);
  font-weight: 500;
  visibility: hidden;
  height: 1px;
  color: transparent;
  margin-bottom: -1px;
  overflow: hidden;
}
/* 伪元素 */
.aboutNews {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-image: url('../assets/img/header/about_more_news.png');
    cursor: pointer;
    text-align: center;
    background-size: 100%;
    vertical-align: middle;
}
._el_dropdown {
    display: inline-block;
}
._div {
    display: inline-block;
    position: relative;
}
._input {
    width: 166px;
    border-radius: 3px;
    outline: none !important;
}
._sprite_class {
    display: inline-block;
    width: 15px;
    height: 14px;
    background-image: url('../assets/img/header/filter_search_icon.png');
    position: absolute;
    left: 8px;
    top: 8px;
    cursor: pointer;
    text-align: center;
    background-size: 100%;
}
.filterShowClass {
    display: inline-block;
    width: 13px;
    height: 12px;
    background-image: url('../assets/img/header/filter_show_icon.png');
    vertical-align: middle;
    cursor: pointer;
    text-align: center;
    background-size: 100%;
    position: relative;
    top: -1px;
}
.allTypeFilter {
    display: inline-block;
    width: 15.5px;
    height: 10.1px;
    background-image: url('../assets/img/header/select_bottom_icon.png');
    vertical-align: middle;
    cursor: pointer;
    text-align: center;
    background-size: 100%;
    /* margin-left: 11px; */
    margin-top: 7px;
}
._el_dropdown {
    display: inline-block;
}
</style>
<style>
#thirdNav .el-input--mini .el-input__inner {
    width: 166px;
    height: 30px;
    padding-left: 29px !important;
}
/* tooltip */
.appAnalysisTooltipItem {
    padding: 6px!important;
    border: 1px solid #d6d6d6!important;
    text-align: left;
    -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    letter-spacing: 0.7px;
    color: rgba(51, 51, 51, 0.8);
    font-weight: 300;
    width: 144px;
}
.appAnalysisTooltipItem .popper__arrow {
    border-top-color: #d6d6d6!important;
    border-bottom-color: #d6d6d6!important;
}
/* tooltip */
#thirdNav .el-dropdown {
    left: 10px;
    width: 91px;
    margin-right: 10px;
    cursor: pointer;
    left: 10px;
    width: 99px;
    /* padding-right: 5px; */
    cursor: pointer;
    /* border: 2px solid #ffffff; */
    box-sizing: inherit;
    border-radius: 4px;
    line-height: 24px;
    box-sizing: border-box;
}
#thirdNav .el-icon--right {
    visibility: visible !important;
    margin-left: 10px;
}
.el-dropdown-menu {
    width: 90px !important;
}
.el-dropdown-menu__item {
    padding: 0px 10px !important;
}
#headerId .el-icon-arrow-down {
    font-weight: 700;
}
#thirdNav .el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
    background-color: #ffffff !important;
    /* border: 2px solid rgba(0, 224, 218, 0.5)!important; */
}
#thirdNav .el-input__inner:focus {
    border: 2px solid rgba(0, 224, 218, 0.5) !important;
}
</style>
